import { z } from 'zod/v3';

export const APPLICATION_ACCESS_GRANT_SCHEMA_VERSION = 1;

export const ApplicationAccessGrant = z.object({
  externalId: z.string(),
  applicationExternalId: z.string(),
  applicationName: z.string().nullable(),
  principalType: z.enum(['user', 'group', 'service_account', 'unknown']),
  principalExternalId: z.string(),
  principalName: z.string().nullable(),
  assignmentType: z.enum(['direct', 'group', 'unknown']),
  status: z.enum(['active', 'provisioned', 'suspended', 'inactive', 'unknown']),
  assignedAt: z.string().datetime().nullable(),
  updatedAt: z.string().datetime().nullable(),
});

export type ApplicationAccessGrant = z.infer<typeof ApplicationAccessGrant>;
